import React, {useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import AdminPanelLayaut from "./layaut/AdminPanelLayaut";
import {downloadFile, getZgloszenie, putKomentarz, setStatus} from "../Services";
import {Badge, Descriptions, DescriptionsProps, Table, Image, Select, Button, Flex, Card, Input, message} from "antd";
import dayjs from "dayjs";
import {iconTyp, isEmpty, statusyType} from "../../../GlobalServices";
import axios from "axios";
import { HOST_API } from "../../../AppConfig";
import Komentarze from "./component/Komentarze";

const { TextArea } = Input;

const Zgloszenie = () => {
    const params: any = useParams();
    const [zgloszenie, setZgloszenie]: any = useState();
    const [images, setImages] = useState([]);
    const [currentImage, setCurrentImage] = useState(0);
    const [visible, setVisible] = useState(false);
    const [showOdpForm, setShowOdpForm] = useState(false);
    const [odpowiedz, setOdpowiedz] = useState('');
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        pobierzZgloszenie(params.idZgl);
    }, []);

    const pobierzZgloszenie = (id: any) => {
        getZgloszenie(id).then((response) => {
            setZgloszenie(response.data);
        }).catch((error) => {
            console.log(error);
        })
    }

    const onClickFile = (plik: any, pliki: any) => {
        if(images.length < 1){
            let zdj: any = [];
            let ile = pliki.filter((p: any) => p.typ.indexOf('jpeg') !== -1 || p.typ.indexOf('image') !== -1).length;

            pliki.forEach( (p: any) => {
                if(p.typ.indexOf('jpeg') !== -1 || p.typ.indexOf('image') !== -1) {
                    axios({
                        method: 'GET',
                        url: HOST_API + 'api/plik/get/' + p.id,
                        responseType: 'blob',
                        // headers: {'Authorization': 'Basic ' + JSON.parse(localStorage.userLoggedZgloszenia).credentials}
                    }).then((response) => {
                        zdj.push({
                            src: URL.createObjectURL(response.data),
                            caption: p.nazwa,
                            id: p.id
                        });
                        ile--;
                        if(ile === 0){
                            zdj = [...zdj].sort((a, b) => a.id - b.id);
                            setImages(zdj);
                            // console.log('pobralem')
                            setVisible(true);
                        }
                    })
                }
            });

        } else {
            setVisible(true);
        }
    }

    const onSelectStatus = (status: string) => {
        let dane = {
            sygnal_id: params.idZgl,
            status: status
        }

        setStatus(dane).then((response) => {
            messageApi.open({
                type: 'success',
                content: 'Zmieniono status zgłoszenia',
                duration: 5,
            });
            pobierzZgloszenie(params.idZgl);
        }).catch((error) => {
            console.log('error');
        })
    }

    const items: DescriptionsProps['items'] = [
        {
            key: '1',
            label: 'Imię i nazwisko',
            children: <>{zgloszenie?.zgloszenie?.imie} {zgloszenie?.zgloszenie?.nazwisko}</>,
            // span: 1
        },
        {
            key: '2',
            label: 'E-mail',
            children: zgloszenie?.zgloszenie?.email,
        },
        {
            key: '3',
            label: 'Data wpisu',
            children: dayjs(zgloszenie?.zgloszenie?.dataWpisu).format('YYYY-MM-DD HH:mm'),
        },
        {
            key: '4',
            label: 'Status',
            children: <>
                {/*<Badge status="warning" style={{marginRight: 15}} />*/}
                <Select
                    defaultValue="nowe"
                    value={zgloszenie?.zgloszenie?.status}
                    style={{ width: 150 }}
                    onChange={(value) => onSelectStatus(value)}
                    options={statusyType}
                />
            </>,
            span: 3,
        },
        {
            key: '5',
            label: 'Kogo dotyczy',
            children: zgloszenie?.zgloszenie?.kogoDotyczy,
            // span: 2
        },
        {
            key: '6',
            label: 'Miejsce',
            children: zgloszenie?.zgloszenie?.miejsce,
            // span: 2
        },
        {
            key: '7',
            label: 'Kiedy',
            children: isEmpty(zgloszenie?.zgloszenie?.dataOd) || isEmpty(zgloszenie?.zgloszenie?.dataOd) ?
                null
                :
                <>{dayjs(zgloszenie?.zgloszenie?.dataOd).format('YYYY-MM-DD')} - {dayjs(zgloszenie?.zgloszenie?.dataDo).format('YYYY-MM-DD')}</>
            // span: 2
        },
        {
            key: '8',
            label: 'Opis sytuacji',
            children: zgloszenie?.zgloszenie?.opis,
            span: 3
        },
        {
            key: '9',
            label: 'Dokumentacja',
            children: <>{zgloszenie?.pliki.length > 0 ? <div className={'col-md-12'}>
                {zgloszenie.pliki.map((plik: any, index: number) => {
                    if(plik.typ.indexOf('jpeg') !== -1 || plik.typ.indexOf('image') !== -1){
                        return <div className={'fileDokumentacja'} onClick={() => {
                            setCurrentImage(index);
                            onClickFile(plik, zgloszenie?.pliki);
                        }}>
                            {iconTyp(plik.typ)} {plik.nazwa} ({parseFloat(plik.rozmiar) / 1000} kb)
                        </div>
                    } else {
                        return <div className={'fileDokumentacja'} onClick={() => downloadFile(plik)}>
                            {iconTyp(plik.typ)} {plik.nazwa} ({parseFloat(plik.rozmiar) / 1000} kb)
                        </div>
                    }
                })}
            </div> : null}</>,
                // <>{zgloszenie?.pliki.length > 0 ? <div className={'col-md-12'}>
                //     {zgloszenie.pliki.map((plik: any, index: number) => {
                //         if(plik.typ.indexOf('jpeg') !== -1 || plik.typ.indexOf('image') !== -1){
                //             return <div className={'fileDokumentacja'} onClick={() => {
                //                 setVisible(true);
                //                 onClickFile(plik, zgloszenie?.pliki);
                //             }}>
                //                 {iconTyp(plik.typ)} {plik.nazwa} ({parseFloat(plik.rozmiar) / 1000} kb)
                //             </div>
                //         } else {
                //             return <div className={'fileDokumentacja'} onClick={() => downloadFile(plik)}>
                //                 {iconTyp(plik.typ)} {plik.nazwa} ({parseFloat(plik.rozmiar) / 1000} kb)
                //             </div>
                //         }
                //     })}
                // </div> : null}</>,
        },
    ];

    const onClickDodaj = () => {
        let dane = {
            sygnal_id: params.idZgl,
            tresc: odpowiedz
        }

        putKomentarz(dane).then((response) => {
            setOdpowiedz('');
            setShowOdpForm(false);
            pobierzZgloszenie(params.idZgl);
        }).catch((error) => {
            console.log('error');
        })
    }

    return (
        <AdminPanelLayaut>

            <Descriptions title={`Zgłoszenie numer ${zgloszenie?.zgloszenie?.numer}`} bordered items={items} size={'small'} />

            <Image.PreviewGroup
                preview={{
                    visible,
                    onChange: (current, prev) => setCurrentImage(current),
                    onVisibleChange: (value) => {
                        setVisible(value);
                    },
                    current: currentImage
                }}
            >
                {images.map((plik: any, index: number) => <Image style={{display: 'none'}} src={plik.src}/>)}
            </Image.PreviewGroup>

            {showOdpForm ?
                <Flex justify={'center'}>
                    <Card title={'Dodaj odpowiedź'} size={'small'} style={{margin: '15px', minWidth: '800px', maxWidth: '1200px'}}>
                        <TextArea
                            value={odpowiedz}
                            onChange={(e) => setOdpowiedz(e.target.value)}
                            placeholder="Wpisz odpowiedź..."
                            autoSize={{ minRows: 3, maxRows: 5 }}
                        />
                        <Flex justify={'space-between'} style={{marginTop: '10px'}}>
                            <Button onClick={() => {setOdpowiedz(''); setShowOdpForm(false);}}>Anuluj</Button>
                            <Button type={'primary'} onClick={onClickDodaj}>Dodaj</Button>
                        </Flex>
                    </Card>
                </Flex>
                :
                <Flex justify={'center'} style={{marginTop: '15px'}}><Button onClick={() => setShowOdpForm(true)}>Dodaj odpowiedź</Button></Flex>
            }

            <Komentarze komentarze={zgloszenie?.komentarz}/>

            {contextHolder}
        </AdminPanelLayaut>
    )
}

export default Zgloszenie;
